module.exports = __webpack_public_path__ + "static/media/Clock-alarm-electronic-beep.c9d839e1.mp3";